// Force every Date display to Pacific Time (America/Los_Angeles).
// Must run BEFORE any component imports — monkey-patches Date.prototype
// so all toLocaleString/toLocaleDateString/toLocaleTimeString calls
// throughout the app render in PT regardless of the user's browser TZ.
// See utils/forcePacificTime.js for the full rationale.
import "@/utils/forcePacificTime";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
// react-snap prerender support: when the DOM was hydrated from a prerendered
// snapshot (react-snap sets `data-react-snap` on the root), use hydrateRoot
// so the SPA reuses the static HTML instead of blanking it and re-rendering.
// Falls back to createRoot for the normal dev/runtime path.
const isPrerendered = rootEl?.hasChildNodes();
if (isPrerendered) {
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
